'use client';

import Link from 'next/link';
import { SearchX, Home, MessageSquare } from 'lucide-react';
import { Shadcn } from '@/components/ui/scope';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { contactHref } from '@/lib/contactHref';

export default function NotFound() {
  return (
    <Shadcn className="flex min-h-screen items-center justify-center bg-background p-3">
      <Card className="w-full max-w-[460px] p-6 text-center sm:p-10">
        <div className="flex flex-col items-center gap-4">
          <span className="flex h-16 w-16 items-center justify-center rounded-md bg-muted text-muted-foreground">
            <SearchX className="h-8 w-8" />
          </span>
          <h1 className="text-[22px] font-extrabold tracking-[-0.02em] text-foreground sm:text-[26px]">
            Page not found
          </h1>
          <p className="text-sm text-muted-foreground">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>

          {/* Public visitors land here far more often than signed-in users
              (bad backlinks, stale search results), so both CTAs point at
              public routes — /home is gated and would bounce them to login. */}
          <div className="mt-2 flex w-full flex-col justify-center gap-3 sm:flex-row">
            <Button asChild className="font-bold">
              <Link href="/">
                <Home className="h-4 w-4" />
                Back to home
              </Link>
            </Button>
            <Button asChild variant="outline" className="font-semibold">
              <Link href={contactHref('other', '404')}>
                <MessageSquare className="h-4 w-4" />
                Contact us
              </Link>
            </Button>
          </div>

          <Link href="/login" className="text-[13px] font-medium text-muted-foreground underline-offset-4 hover:underline">
            Sign in to your account
          </Link>
        </div>
      </Card>
    </Shadcn>
  );
}
